import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function StorySection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].story;
  return <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-teal-950 to-black" data-id="element-554">
      <div className="max-w-4xl mx-auto" data-id="element-555">
        <div className="bg-gradient-to-br from-red-950/30 to-black border-2 border-red-600/50 rounded-2xl p-6 md:p-12" data-id="element-556">
          <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-557">
            <AlertTriangleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-400" data-id="element-558" />
            <h2 className="text-xl md:text-3xl font-bold text-red-400" data-id="element-559">
              {t.warning}
            </h2>
          </div>
          <p className="text-lg md:text-xl mb-6 md:mb-8 text-red-300" data-id="element-560">
            {t.warningText}
          </p>
        </div>
        <div className="mt-8 md:mt-12 bg-gradient-to-br from-teal-950/50 to-black border border-teal-700/30 rounded-2xl p-6 md:p-12" data-id="element-561">
          <div className="mb-4 md:mb-6" data-id="element-562">
            <p className="text-base md:text-lg text-teal-300" data-id="element-563">
              {t.from} <span className="font-bold text-white" data-id="element-564">{t.author}</span>
            </p>
            <p className="text-base md:text-lg text-teal-300" data-id="element-565">
              {t.location}{' '}
              <span className="font-bold text-white" data-id="element-566">{t.locationText}</span>
            </p>
          </div>
          <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-567">
            <p data-id="element-568">
              {t.paragraph1}{' '}
              <span className="text-yellow-400 font-semibold" data-id="element-569">{t.cracked}</span>
            </p>
            <p data-id="element-570">
              {t.paragraph2}{' '}
              <span className="text-red-400 font-semibold" data-id="element-571">{t.scripted}</span>{' '}
              {t.paragraph2b}
            </p>
            <p data-id="element-572">
              {t.paragraph3}{' '}
              <span className="text-yellow-400 font-bold" data-id="element-573">{t.bookTitle}</span>{' '}
              {t.paragraph3b}
            </p>
          </div>
        </div>
      </div>
    </section>;
}